// extracted by mini-css-extract-plugin
module.exports = {"logo":"GoFarRewardsLogo__logo___2R6e-","desktop":"GoFarRewardsLogo__desktop___19gqR","mobile":"GoFarRewardsLogo__mobile___20YOR"};